import ApplicationController from "./application_controller";

export default class extends ApplicationController {
    static targets = [
        "carrier",
        "activeFrom",
        "activeTo",
        "state"
    ]

    filter() {
        const filters = {
            carrier: this.carrierTarget.value,
            state: this.stateTarget.value,
            active_from: this.activeFromTarget.value,
            active_to: this.activeToTarget.value
        }
        this.stimulate("RateReflex#filter", filters);
    }
}
